import React from "react";
import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import Contents from "../components/pages/findPassword/en/Contents";

const FindPassword = () => {
    return (
        <>
            <Header />
            <Contents />
            <Footer />
        </>
    );
};

export default FindPassword;